import React from 'react';
import { useLocation } from 'react-router-dom';
import { clearDemoState } from '../clearDemoState';
import '../demo-exit-chip.css';

function isDemoStateSet() {
  try {
    if (localStorage.getItem('demo:enabled') === 'true') return true;
    const params = new URLSearchParams(window.location.search);
    return params.get('demo') === 'true' || !!params.get('demo_brand');
  } catch {
    return false;
  }
}

function DemoExitChip() {
  const { pathname } = useLocation();
  const [active, setActive] = React.useState(isDemoStateSet);

  React.useEffect(() => {
    const sync = e => {
      if (!e || e.key === null || e.key.startsWith('demo:')) setActive(isDemoStateSet());
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  // Re-evaluate on every route change (covers nav into/out of /demo/* and
  // any URL-param changes via push/replace).
  React.useEffect(() => { setActive(isDemoStateSet()); }, [pathname]);

  if (pathname.startsWith('/demo/') || !active) return null;

  const handleExit = () => {
    clearDemoState();
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('demo');
      url.searchParams.delete('demo_brand');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch { /* ignore */ }
    window.location.reload();
  };

  return (
    <button
      type="button"
      className="demo-exit-chip"
      data-testid="demo-exit-chip"
      onClick={handleExit}
    >
      Exit demo mode
    </button>
  );
}

export default DemoExitChip;
